module.exports = __webpack_public_path__ + "img/ic_user_avatar_service.fc0fe49b.png";